import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { GrnReturnItemSaveDto } from './grn-return-save.dto';


export class GrnItemReturnResponseModel extends GlobalResponseObject {
    data?: GrnReturnItemSaveDto;

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: GrnReturnItemSaveDto) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}

 